import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M14.67 4.388L10.613.33A1.14 1.14 0 009.818 0H1.125A1.125 1.125 0 000 1.125v15.75A1.125 1.125 0 001.125 18h13.5a.375.375 0 00.375-.375V5.183a1.14 1.14 0 00-.33-.795zM5.865 8.384L3.337 7.44A1.905 1.905 0 012.25 5.587 1.897 1.897 0 013.967 3.69a.187.187 0 00.158-.188V3a.75.75 0 011.5 0v.473a.187.187 0 00.188.187h.937a.75.75 0 010 1.5H4.41c-.66 0-.66.322-.66.428a.698.698 0 00.135.465l2.527.944A1.905 1.905 0 017.5 8.85a1.897 1.897 0 01-1.718 1.898.188.188 0 00-.157.187v.502a.75.75 0 11-1.5 0v-.464a.188.188 0 00-.188-.188H3a.75.75 0 110-1.5h2.34c.66 0 .66-.33.66-.435a.698.698 0 00-.135-.465zm6.51 2.678a.562.562 0 110 1.124h-3.75a.563.563 0 010-1.124h3.75zM9.562 8.25a.57.57 0 01.563-.563h2.25a.562.562 0 110 1.125h-2.25a.57.57 0 01-.563-.562zm2.813 6.188a.562.562 0 110 1.124h-7.5a.563.563 0 010-1.124h7.5z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
